module.exports = __webpack_public_path__ + "static/media/experience-unique-homes.5305f020.webp";